import { Fade, DialogContent, Dialog } from '@material-ui/core';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import { SERVER_URL } from '../../utils/config/constants';
import { NotificationManager } from 'react-notifications';
import { getCookies } from '../../utils/getToken';
class NewServiceSuggestionDialog extends React.Component {

    constructor() {
        super();
        this.state = {
            showSuggestionDialog: true,
            description: "",
            serviceName: ""

        }
    }
    closeDialog = () => {
        this.props.closeDialog()
    }
    addServiceSuggestion = () => {
        var authToken = getCookies();
        console.log("adding suggestion")
        axios({
            method: 'post',
            url: `${SERVER_URL}/user/service-suggestion`,
            data: {
                description: this.state.description,
                suggested_name: this.state.serviceName
            },
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {
                NotificationManager.success("Success!", resJson.data.message),
                    this.setState({
                        showSuggestionDialog: false
                    }, () => { this.props.closeDialog() })
            }
            else if (resJson.data.status == "NOK") {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    showSuggestionDialog: false
                }, () => {
                    this.props.closeDialog()
                })
            }
            else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.props.closeDialog()
            }
        })
    }
    render() {
        const {
            description
        } = this.state;
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-suggestion-modal md-4 align-self-center"
                    open={this.state.showSuggestionDialog}
                    onClose={this.closeDialog}
                    fullWidth
                    aria-labelledby="form-dialog-title"
                >
                    <div style={{ backgroundColor: "white" }} className="col p-3 custom-input-text">
                        <form className="form-new">
                            <TextField id="standard-basic" label="Service Name"
                                placeholder="Enter service name"
                                className="login-form-textfield" fullWidth onChange={event => {
                                    this.setState({
                                        serviceName: event.target.value,
                                    });
                                }} />
                        </form>
                        <form className="form-new">
                            <TextField id="standard-basic"
                                placeholder="Enter description"
                                label="Description" className="login-form-textfield" fullWidth onChange={event => {
                                    this.setState({
                                        description: event.target.value,
                                    });
                                }} />
                        </form>
                        <div className="md-12 d-flex justify-content-center">
                            <button type="button" class="custom-button"
                                onClick={() => {
                                    this.addServiceSuggestion()
                                }}>ADD SUGGESTION</button>
                        </div>

                    </div>
                </Dialog>

            </div>
        )
    }
}

export default NewServiceSuggestionDialog;


// WEBPACK FOOTER //
// ./src/components/Dialogs/NewServiceSuggestionDialog.jsx